


























import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Button from "@/components/Button/Button.vue";
import * as types from "@/store/constants/index_types";
import * as setting_types from "@/store/constants/setting_types";
import { playVideo, playVideoEffect } from "@/services/watch_video";
import RateUsItem from "./RateUsItem/RateUsItem.vue";

@Component({
  components: {
    Button,
    RateUsItem
  }
})
export default class DailyChallenge extends Vue {
  @Getter(types.GETTER_MASTER_USER_ID)
  private masterId: any;
  @Getter(setting_types.GETTER_TAB_COIN_STORE_SETTINGS)
  private settingData: any;
  private hasRequst: boolean = false;

  private async clickWatchVideo() {
    playVideoEffect("free_coins");
  }

  get watchVideoReward() {
    return this.settingData.rewards.video;
  }
}
